
import { debounce } from './utils';

;(function($, window, document) {

  const blocks = $('.block-text_image.block-bg-panel');

  if (blocks.length > 0) {

    $.each(blocks, function() {

      const block = $(this);
      setHeight(block);
      $(window).on('resize', debounce(function() {
        setHeight(block); 
      }));

    });

  }



  function setHeight(block: any) {

    const windowWidth = $(window).width();

    if (windowWidth < 1024) {
      // Reset height on mobile
      const panel = block.find('.tms-swirl');
      if (panel.length > 0) {
        panel.css('height', '100%');
      }
      return;
    }

    const textContent = block.find('.content-text')[0];
    const height = textContent ? textContent.clientHeight + 80 : 0;

    const panel = block.find('.tms-swirl');
    if (panel.length > 0) {
      panel.css('height', height + 'px');
    }
  }
  

// @ts-ignore
})(jQuery, window, document);